import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import { Select } from "@ds/ds-snam/react";
import { IContractElement } from "dataModels/contract";
import useAppUser from "hooks/useAppUser";
import { getContracts, getCustomerDomain } from "net/contracts";
import { AppUser } from "ooAuth2/appUser";
import React, { ReactNode, useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { AppUserGrant, AppUserRole, DsLayout, IAppUserProfile } from "shared/constants";
import { dsPreSelectHandler, dsSelectHandler } from "shared/utils/dsComponentUtils";
import { RootState } from "state/appStore";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";


interface IClientContractFilterProps{
    selectContractId:(arg0:string | undefined)=>void
    selectBusinessId:(arg0:string | undefined)=>void
    selectSelectedBusiness : (arg0:ISelectLabel | undefined)=>void
    selectedBusiness:ISelectLabel|undefined
    inCalendar?:boolean
}

const ClientContractFilter: React.FC<IClientContractFilterProps> = (props): JSX.Element => {

    const appUserProfile: IAppUserProfile | undefined = useAppUser()?.userProfile;
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })

    const { t, i18n } = useTranslation(['contract', 'preBilling', 'app', 'dashboard']);
    const dispatch = useDispatch();

    const [customerList, setCustomerList] = useState<ISelectLabel[]>([]);
    const [contractList, setContractList] = useState<IContractElement[] | undefined>();
    const [contractISelectLabel, setContractISelectLabel] = useState<ISelectLabel[]>([]);
    
    const loadCustomers = useCallback(() => {
        dispatch(requestPending());
        getCustomerDomain('b2b')
            .then((response: ISelectLabel[]) => {
                //console.log(response)
                dsPreSelectHandler(response, response[0].value!);
                setCustomerList(response)
                props.selectSelectedBusiness(response[0]);
                props.selectBusinessId(response[0].value!)
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                dispatch(requestPristine())
            })
    }, [dispatch]);
    const loadContractList = useCallback(() => {
        dispatch(requestPending());
        getContracts('b2b')
            .then((response: any) => {
                setContractList(response.data);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
    }, [dispatch]);
    useEffect(() => {
        loadContractList();
        loadCustomers();
    }, []);
    useEffect(()=>{
        //console.log(props.selectedBusiness)
        if(props.selectedBusiness){
            let myArray = [];
            if(contractList && contractList[0]){
                myArray.push({ id: contractList[0].contractId, label: contractList[0].contractCode, value: contractList[0].contractId })
            }
            for (let i in contractList) {
                if(contractList[Number(i)].businessName===props.selectedBusiness.label){
                    myArray.push({ id: contractList[Number(i)].contractId, label: contractList[Number(i)].contractCode, value: contractList[Number(i)].contractId })
                }
            }
            if(myArray[0]){
                //console.log(myArray[0])
                dsPreSelectHandler(myArray, myArray[0].value!);
                //setContractId(myArray[0].value!)
                props.selectContractId(myArray[0].value)
            }else{
                props.selectContractId(undefined)
            }
            setContractISelectLabel(myArray);
        }
    },[props.selectedBusiness])

    return (
        <div>
        {/**Seleziona cliente e contratto */}
        {appUserProfile?.dashboardGrants.includes(AppUserGrant.CALENDAR_MENU) &&
                    <Row className="listTableContainerGrey" style={{marginBottom: '25px',marginLeft:props.inCalendar?'0px':'-15px',marginRight:/*props.inCalendar?*/'-15px'/*:'-15px'*/,/*,padding:'24px',borderRadius:'12px',background:'var(--Neutrali-50, #EFF1F5)', */}} >
                        <Col xs={12} md={12} className="pageSubTitle" style={{ paddingLeft:'0px',fontFamily: 'Lato, Lato-local, sans-serif', marginBottom: '20px', fontWeight: 'bold' }}>
                            {appUserRole!==AppUserRole.CUSTOMER ?
                                <>{t("dashboard.titles.0",{ns:'dashboard'})} {/** Seleziona cliente e contratto*/}</>
                            :
                                <>{t("dashboard.titles.9",{ns:'dashboard'})} {/** Seleziona contratto*/}</>
                            }
                        </Col>
                        {appUserRole!==AppUserRole.CUSTOMER &&
                            <Col xs={12} md={3} style={{paddingLeft:'0px',marginRight:'-7px'}}>
                                <Select
                                    id="customerSelector"
                                    selectId="customerSelector"
                                    menuPlaceholder=""
                                    hasIcon={false}
                                    menuOptions={customerList}
                                    menuLabel={t("dashboard.labels.0",{ns:'dashboard'})}
                                    menuId="select-id"
                                    isDisabled={customerList.length===0 ? true : false}
                                    selectStatus="default"
                                    onOptionSelection={(event: Event) => {
                                        const customer: ISelectLabel = (event as CustomEvent).detail.option;
                                        dsSelectHandler(customerList, customer);
                                        props.selectBusinessId(customer.value!)
                                        props.selectSelectedBusiness(customer);
                                    }}
                                ></Select>
                            </Col>
                        }
                        <Col xs={12} md={3}>
                            <Select
                                id="customerSelector"
                                selectId="customerSelector"
                                menuPlaceholder=""
                                hasIcon={false}
                                menuOptions={contractISelectLabel ? contractISelectLabel : []}
                                menuLabel={t("dashboard.labels.1",{ns:'dashboard'})}
                                menuId="select-id"
                                isDisabled={contractISelectLabel.length===0 ? true : false}
                                selectStatus="default"
                                onOptionSelection={(event: Event) => {
                                    const contract: ISelectLabel = (event as CustomEvent).detail.option;
                                    const contractId: string = (event as CustomEvent).detail.option.value;
                                    dsSelectHandler(contractISelectLabel, contract);
                                    props.selectContractId(contractId)
                                }}
                            ></Select>
                        </Col>

                        
                    </Row>
                }
        </div>
    );
}
export default ClientContractFilter;